package com.milta.feature.route.domain.usecase

import com.milta.feature.route.domain.entity.RouteOptimizationResult
import com.milta.feature.route.domain.repository.RouteRepository

/** POST /api/v1/routes/{id}/optimize (DOM-02). */
class OptimizeRouteUseCase(private val repository: RouteRepository) {
    suspend operator fun invoke(routeId: String): RouteOptimizationResult = repository.optimizeRoute(routeId)
}
